import CreateMembershipRequestModelBase from '../_generated/modelBases/create-membership-request-model-base';

export default class CreateMembershipRequestModel extends CreateMembershipRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
